"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCheckDigit = exports.FORMAT_ERR = exports.EMPTY_CODE_ERR = exports.NONSTRING_ERR = void 0;
exports.NONSTRING_ERR = 'Barcode must be a string';
exports.EMPTY_CODE_ERR = 'Barcode must not be an empty string';
exports.FORMAT_ERR = 'Barcode is not of a valid format';
function to13Digits(barcode) {
    return barcode.padStart(13, '0');
}
// This assumes the barcode does not have a check digit,
// AND has a number system on it.
function generateCheckDigit(barcode) {
    return String((10 - ((to13Digits(barcode)
        .split('')
        .map((num, idx) => ((+num) * ((idx % 2 === 0) ? 3 : 1)))
        .reduce((prev, cur) => prev + cur)) % 10)) % 10);
}
exports.generateCheckDigit = generateCheckDigit;
